import classNames from "classnames";
import styles from "./Container.module.css";
import { Ref, type PropsWithChildren, type JSX } from "react";

type ContainerProps = PropsWithChildren<{
  fullWidth?: boolean;
  breakOutSticky?: boolean;
  reducedGap?: boolean;
  increasedGap?: boolean;
  innerRef?: Ref<HTMLElement>;
}>;

const Container = (props: ContainerProps): JSX.Element => {
  const {
    children,
    innerRef,
    fullWidth = false,
    breakOutSticky = false,
    reducedGap = false,
    increasedGap = false,
  } = props;

  const containerClassNames = classNames(styles.container, {
    [styles.fullWidth]: fullWidth,
    [styles.breakOutSticky]: breakOutSticky,
    [styles.reducedGap]: reducedGap,
    [styles.increasedGap]: increasedGap,
  });

  return (
    <section className={containerClassNames} ref={innerRef}>
      {children}
    </section>
  );
};

export { Container };
